export const CONTACT_FIELD_ORDER = [
  "name",
  "email",
  "phone",
  "company",
  "message",
  "consent",
] as const;

export type ContactFieldName = (typeof CONTACT_FIELD_ORDER)[number];
export type ContactTextFieldName = Exclude<ContactFieldName, "consent">;

export const CONTACT_MIN_LENGTH = {
  name: 2,
  message: 10,
} as const;

export const CONTACT_MAX_LENGTH = {
  name: 100,
  email: 254,
  phone: 30,
  company: 200,
  message: 5000,
} as const;

export const CONTACT_EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

// Permissive phone validation for international formats.
export const CONTACT_PHONE_REGEX = /^[+()\-\s0-9]{6,30}$/;
